import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const FooterView = ({
  type,
  register = false,
  login = false,
  reset = false,
}) => {
  const { t } = useTranslation();

  return (
    <Box mt={2} mb={2}>
      {register ? (
        <Typography color="textSecondary" variant="body1">
          {t("register.dont_have_account")}
          <Link component={RouterLink} to="/register" variant="h6">
            {t("register.sign_up")}
          </Link>
        </Typography>
      ) : null}

      {reset ? (
        <Typography color="textSecondary" variant="body1">
          {t("reset.dont_remember_password")}
          <Link component={RouterLink} to={type ? `/reset/${type}` : "/reset"} variant="h6">
            {t("reset.reset")} Password
          </Link>
        </Typography>
      ) : null}

      {login ? (
        <Typography color="textSecondary" variant="body1">
          {t("login.have_account")}
          <Link component={RouterLink} to={type ? `/login/${type}` : "/"} variant="h6">
            {t("login.sign_in")}
          </Link>
        </Typography>
      ) : null}
    </Box>
  );
};

export default FooterView;
